export const ActionTypes = {
  SET_OEE_GRID: 'services/dashboards/oeeGridDashboard/set_oee_grid',
  FETCH_ASSEMBLY_LINE_GRID: 'services/dashboards/oeeGridDashboard/fetch_assembly_line_grid',
  SET_ASSEMBLY_LINE_GRID: 'services/dashboards/oeeGridDashboard/set_assembly_line_grid',
  SET_LOADER_STATUS: 'services/dashboards/oeeGridDashboard/set_loader_status',
  IS_ASSEMBLY_DASHBOARD: 'services/dashboards/oeeGridDashboard/is_assembly_dashboard',
  SET_SELECTED_GROUPS: 'services/dashboards/oeeGridDashboard/set_selected_groups',
  SET_SELECTED_COLUMNS: 'services/dashboards/oeeGridDashboard/set_selected_columns',
  SET_SHOW_FAMILY_PRODUCTION: 'services/dashboards/oeeGridDashboard/set_show_family_production',
};

const setOeeGrid = ({ oeeGrid }) => ({
  oeeGrid,
  type: ActionTypes.SET_OEE_GRID,
});
const fetchAssemblyLineGrid = ({ oeeGridParams }) => ({
  oeeGridParams,
  type: ActionTypes.FETCH_ASSEMBLY_LINE_GRID,
});

const setAssemblyLineGrid = ({ oeeGrid }) => ({
  oeeGrid,
  type: ActionTypes.SET_ASSEMBLY_LINE_GRID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const isAssemblyDashboard = ({ assemblyLine }) => ({
  assemblyLine,
  type: ActionTypes.IS_ASSEMBLY_DASHBOARD,
});
const setSelectedGroups = ({ selectedGroups }) => ({
  selectedGroups,
  type: ActionTypes.SET_SELECTED_GROUPS,
});

const setSelectedColumns = ({ selectedColumns }) => ({
  selectedColumns,
  type: ActionTypes.SET_SELECTED_COLUMNS,
});
const setShowFamilyProduction = ({ showFamilyProduction }) => ({
  showFamilyProduction,
  type: ActionTypes.SET_SHOW_FAMILY_PRODUCTION,
});

export default {
  setOeeGrid,
  fetchAssemblyLineGrid,
  setAssemblyLineGrid,
  setLoader,
  isAssemblyDashboard,
  setSelectedGroups,
  setSelectedColumns,
  setShowFamilyProduction,
};
